import request from "./request";
import {graphqlOperation} from "aws-amplify";
import {createSdpUser, updateSdpUser, deleteSdpUser} from "../graphql/mutations";
import {getSdpUser, listSdpUsers} from "../graphql/queries";

export const userApi = {
  createUser: async ({ user }) => {
    return (
      await request(graphqlOperation(createSdpUser, { input: user }))
    ).createSdpUser;
  },
  getUser: async ({ user }) => {
    return (
      await request(graphqlOperation(getSdpUser, user))
    ).getSdpUser;
  },
  updateUser: async ({ user }) => {
    return (
      await request(graphqlOperation(updateSdpUser, { input: user }))
    ).updateSdpUser;
  },
  deleteUser: async ({ user }) => {
    return (
      await request(graphqlOperation(deleteSdpUser, { input: user }))
    ).deleteSdpUser;
  },
  listUsers: async (params = {}) => {
    return (
      await request(graphqlOperation(listSdpUsers, params))
    ).listSdpUsers;
  }
}
